import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Slide, SxProps, Typography } from '@mui/material';
import { colors } from '../../constants/colors';
import { TransitionProps } from '@mui/material/transitions';
import ContainerButton from '../button/ContainerButton';

interface btnStyle {
    variant?: "contained" | "outlined" | "text";
    color?: 'error' | 'info' | "inherit" | "primary" | "secondary" | "success" | "warning"
}
type Props = {
    title: string;
    open: boolean;
    onClose?: () => void;
    size?: DialogProps['maxWidth'];
    component: JSX.Element;
    btnSubmit?: JSX.Element;
    btnCloseStyle?: btnStyle;
    fullWidth?: boolean;
    maxWidth?: number
    subTitle?: React.ReactNode | string;
    sx?: SxProps;
    disableCloseButton?: boolean;
    mode?: 'edit';
    containerButton?: {
        onClose?: () => void;
        hidden_submit?: boolean;
        disabled_submit?: boolean;
        onSubmit?: () => void;
    }
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="down" timeout={150} ref={ref}  {...props} />;
});

const ModalCustom: React.FC<Props> = (props) => {
    const matchesSize = useMediaQuery('(min-width:600px)');
    return (
        <React.Fragment>
            <Dialog
                TransitionComponent={Transition}
                // sx={{ zIndex: 1200, maxWidth: props.maxWidth ? props.maxWidth : 800, margin: "0 auto" }}
                sx={{
                    zIndex: 1200,
                    maxWidth: props.maxWidth ? props.maxWidth : 800,
                    margin: "0 auto",
                    '& .MuiDialog-paper': {
                        width: props.maxWidth ? `${props.maxWidth}px` : '800px',  // Fixed width for the modal
                        maxWidth: '100%',  // Ensure the modal doesn't exceed the screen width
                    },
                }}
                fullWidth
                maxWidth={props.size || (matchesSize ? 'lg' : 'sm')}
                open={props.open}
                onClose={props.onClose}
                PaperProps={{
                    sx: {
                        boxShadow: "0 0 17px 0 rgba(0,0,0,0.15)",
                        borderRadius: "8px"
                    }
                }}
                BackdropProps={{
                    sx: {
                        backgroundColor: 'rgba(255, 255, 255, 0.3)',
                        WebkitBackdropFilter: 'blur(5px)',
                        backdropFilter: 'blur(5px)',
                    },
                    timeout: 500,
                }}
            >
                <DialogTitle sx={{ textAlign: "center", marginTop: "20px" }}>
                    <Typography variant='h5' sx={{ color: colors.themeMainColor, fontSize: "clamp(24px,3.5vw,28px)" }}>
                        {props.title}
                    </Typography>
                    {props.subTitle && (
                        <Typography
                            variant='subtitle2'
                            sx={{ color: colors.textNormal, mt: 2, fontSize: "clamp(18px,3.0vw,16px)" }}>
                            {props.subTitle}
                        </Typography>
                    )}
                </DialogTitle>
                <DialogContent sx={props.sx}>
                    {props.component}
                </DialogContent>
                {props.containerButton && (
                    <ContainerButton
                        sxContainer={{ my: 3 }}
                        buttonData={[
                            {
                                seq: 1,
                                buttonProps: {
                                    onClick: props.containerButton.onClose,
                                },
                                key: "CANCEL",
                                label: "ยกเลิก",
                                type: "CANCEL"
                            },
                            {
                                seq: 2,
                                buttonProps: {
                                    disabled: props.containerButton.disabled_submit,
                                    onClick: props.containerButton.onSubmit
                                },
                                hidden: props.containerButton.hidden_submit,
                                key: "SAVE",
                                label: "ยืนยัน",
                                type: "SAVE"
                            },
                        ]}
                    />
                )}
                {props.onClose && (
                    <DialogActions sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        padding: "10px"
                    }}>
                        {!props.disableCloseButton && (
                            <Button
                                sx={{ color: colors.black }}
                                color={props.btnCloseStyle?.color}
                                variant={props.btnCloseStyle?.variant}
                                onClick={props.onClose}
                            >
                                <CloseIcon />
                            </Button>
                        )}
                    </DialogActions>
                )}
            </Dialog>
        </React.Fragment>
    );
}
export default ModalCustom
